import { PlannerDynamicSidebarContentType } from "@lifeat/shared/planner/PlannerTypes";
import { AmplitudeEvent } from "@analytics/Amplitude/AmplitudeEvents";

export class SelectPlannerBoardViewEvent extends AmplitudeEvent {
    constructor() {
        super("select_planner_board_view");
    }
}
export class SelectPlannerCalendarViewEvent extends AmplitudeEvent {
    constructor() {
        super("select_planner_calendar_view");
    }
}

export class SelectPlannerProjectsViewEvent extends AmplitudeEvent {
    constructor() {
        super("select_planner_projects_view");
    }
}

export class SelectPlannerInvoicesViewEvent extends AmplitudeEvent {
    constructor() {
        super("select_planner_Invoices_view");
    }
}

export class SelectDynamicSidebarContentEvent extends AmplitudeEvent {
    constructor(props: { content: PlannerDynamicSidebarContentType }) {
        super("select_dynamic_sidebar_content");
        this.props = props;
    }
}

export class ViewFirstTimePlannerOnboardingEvent extends AmplitudeEvent {
    constructor() {
        super("view_first_time_planner_onboarding");
    }
}

export class SkipFirstTimePlannerOnboardingEvent extends AmplitudeEvent {
    constructor() {
        super("skip_first_time_planner_onboarding");
    }
}
